import { useEffect, useState } from 'react';
import { AlertTriangle, Wallet } from 'lucide-react';
import { adminDomainService, type AdminDomainBalance } from '@/domains/domains-registry/services/adminDomainService';
import { formatZAR } from '@/shared/utils/format';

export function DomainsBalanceBanner() {
  const [data, setData] = useState<AdminDomainBalance | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    adminDomainService
      .getBalance()
      .then((b) => {
        if (!cancelled) setData(b);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err.message : String(err));
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <div className="rounded-md border border-warning/30 bg-warning/5 px-4 py-2 text-xs text-warning">
        Could not check reseller balance: {error}
      </div>
    );
  }
  if (!data) {
    return (
      <div className="rounded-md border border-border bg-card-subtle px-4 py-2 text-xs text-muted-foreground">
        Checking reseller balance…
      </div>
    );
  }
  if (data.isBelowFloor) {
    return (
      <div className="flex items-center gap-3 rounded-md border border-danger/40 bg-danger/5 px-4 py-2 text-sm text-danger">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        <span className="flex-1">
          Reseller balance is <strong>{formatZAR(data.balance)}</strong> — below the{' '}
          <strong>{formatZAR(data.balanceFloor)}</strong> floor. Paid mutations are blocked.
          Top up at domains.co.za before registering or renewing.
        </span>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-3 rounded-md border border-border bg-card-subtle px-4 py-2 text-xs text-muted-foreground">
      <Wallet className="h-3.5 w-3.5 shrink-0" />
      <span>
        Reseller balance: <strong className="text-foreground">{formatZAR(data.balance)}</strong>
        {' '}({data.accountType}) · floor <strong className="text-foreground">{formatZAR(data.balanceFloor)}</strong>
        {data.fromCache ? ' · cached' : ' · live'}
      </span>
    </div>
  );
}
